import { render } from "./Contact_1.vue?vue&type=template&id=2541ba5e"
import script from "./Contact_1.vue?vue&type=script&lang=js"
export * from "./Contact_1.vue?vue&type=script&lang=js"

import "./Contact_1.vue?vue&type=style&index=0&id=2541ba5e&lang=scss"
script.render = render

export default script